import { pipe } from 'ramda';
import { Filter } from 'components/molecules/filters/types';
import { AssigneeField, UserId } from 'components/organisms/tasks/fields';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import type { Maybe } from 'core/maybe';
import { map, orElse } from 'core/maybe';

export const restrictToUser =
  (assignee: Maybe<AssigneeField>) =>
  (filter: Filter) =>
  (userId: UserId): Filter => ({
    ...filter,
    criteria: pipe(
      map((field: AssigneeField) =>
        filter.criteria.concat({
          field,
          type: SelectFilterOperationType.IsOneOf,
          value: [userId],
        }),
      ),
      orElse(filter.criteria),
    )(assignee),
  });
